import { UniqueIdentifier } from '@dnd-kit/core';
import { ItemsI } from '../types';

/**
 * FindContainer.
 */
export const findContainerId = (id: UniqueIdentifier, items: ItemsI) => {
  if (id in items) {
    return id;
  }

  return Object.keys(items).find((key) => items[key].includes(id));
};
